export default {
    computed: {
        jwt() {
            return this.$store.state.jwt;
        },
    },
    methods: {
        async web(action, message, payload, expectedErrors) {
            this.$store.commit("setRequestBusy", true);
            this.$store.commit("setOverlayText", message);

            try {
                var headers = {};
                if (this.jwt) {
                    headers['Authorization'] = 'bearer ' + this.jwt;
                }
                if (payload instanceof FormData) {
                    headers['Content-Type'] = 'multipart/form-data';
                }

                var response;
                var url = this.$store.state.apiBaseUrl;

                if (window.location.host.toLowerCase().indexOf("localhost") > -1) {
                    url = "https://localhost:44317/Api";
                }

                if (payload) {
                    response = await this.axios.post(url + action, payload, { headers: headers });
                }
                else {
                    response = await this.axios.get(url + action, { headers: headers });
                }

                return response.data;
            }
            catch (e) {
                console.error(e);

                if (e && e.response) {
                    if (e.response.status == 401) {
                        if (this.$store.state.isAuthenticated) {
                            this.$store.commit("setUserState", null);
                        }
                        if (this.$router.currentRoute.name !== "Home") {
                            this.$router.replace("/");
                        }
                    }
                    else {
                        if (expectedErrors && expectedErrors.indexOf(e.response.status) > -1) {
                            //this error was expected
                        }
                        else {
                            this.$store.commit("setErrorCode", e.response.status);
                        }
                    }
                }
                else {
                    this.$store.commit("setErrorCode", 0);
                }

                throw e;
            }
            finally {
                this.$store.commit("setRequestBusy", false);
                this.$store.commit("setOverlayText", null);

            }
        },
    }
}